import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useFetch } from '../utils/FetchTemplate';
import { IUser } from '../interfaces/User.interface';
import { useAuth } from '../contexts/AuthContext';

const RedirectUpdateUserInfo: React.FC = () => {
    const { getData } = useFetch();
    const [shouldRedirect, setShouldRedirect] = useState(false);
    const {login}     = useAuth();
    useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const user = await getData<IUser>('/api/auth/user-info');
                // update user's info
                login(user);
                setShouldRedirect(true);
            } catch (error) {
                console.error('Error fetching user info:', error);
                setShouldRedirect(true); // Redirect anyway in case of error
            }
        };

        fetchUserInfo();
    }, []);

    return shouldRedirect ? <Navigate to="/dashboard" /> : null;
};

export { RedirectUpdateUserInfo };
